// extracted by mini-css-extract-plugin
export default {"suomifi":"Login_suomifi__paDO0","container":"Login_container__lCF9u"};